"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adminUserDefinition = void 0;
const firestore_1 = require("comodel/firestore");
exports.adminUserDefinition = (0, firestore_1.defineCollection)({
    collectionName: "adminUser",
    idKey: "adminUserId",
    constraints: ["adminUserId"],
    queryDefs: {
        list: ({ createdAt, condition, }) => {
            return {
                queryParams: {
                    filter: { createdAt },
                    orderBy: [["createdAt", "desc"]],
                },
                filterParams: condition,
            };
        },
    },
    defaultValue: {},
    onGenerate: (o) => (Object.assign(Object.assign({}, o), { createdAt: Date.now() })),
    onWrite: (o) => (Object.assign(Object.assign({}, o), { updatedAt: Date.now() })),
});
